import { DataContent } from "components/ui/DataContent";

const WidgetFrameDataContent = DataContent;

export { WidgetFrameDataContent };
